import Vue from "vue";
import Router from "vue-router";
import Portal from "../portal.vue";
import PortalNormal from "../portalNormal.vue";
import login from "../components/login.vue";
import statistics from "../components/Statistics/statistics.vue";
import detail from "../components/inside/detail.vue";
import inform from "../components/inside/inform.vue";
import search from "../components/inside/search.vue";
import result from "../components/inside/result.vue";
import solution from "../components/inside/solution.vue";
// import inforNotice from "../components/inside/inforNotice.vue";

import homePage from "../components/PageAll/homePage.vue";
import portalPage from "../components/PageAll/portalPage.vue";

import infoDetail from "../components/inside/informationDetail.vue";
import workProgressDetail from "../components/inside/workProgressDetail.vue";
import workProgressRight from "../components/inside/workProgressRight.vue";
import searchResult from "../components/inside/search-result.vue";
Vue.use(Router);

//此项目中的通用模板为solution组件，也可以自己添加自定义组件
export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/home",
    },
    {
      path: "/home",
      name: "PortalNormal",
      component: PortalNormal,
      meta: {
        needLogin: true, //需要加校检判断的路由
      },
      children: [
        {
          path: "/",
          name: "HomePage",
          component: homePage,
        },
        {
          path: "detail",
          name: "Detail",
          component: detail,
        },
        {
          path: "solution",
          name: "Solution",
          component: solution,
        },
        {
          path: "inform",
          name: "inform",
          component: inform,
        },
        {
          path: "infoDetail",
          name: "InfoDetail",
          component: infoDetail,
        },
        {
          path: "workProgressDetail",
          name: "WorkProgressDetail",
          component: workProgressDetail,
        },
        {
          path: "workProgressRight",
          name: "WorkProgressRight",
          component: workProgressRight,
        },
        {
          path: "searchResult",
          name: "SearchResult",
          component: searchResult,
        },
      ],
    },
    {
      path: "/Portal",
      name: "Portal",
      component: Portal,
      children: [
        {
          path: "/",
          name: "PortalPage",
          component: portalPage,
        },
        {
          path: "detail",
          name: "Detail",
          component: detail,
        },
        {
          path: "solution",
          name: "Solution",
          component: solution,
        },
        {
          path: "inform",
          name: "inform",
          component: inform,
        },
      ],
    },
    {
      path: "/login",
      name: "login",
      component: login,
    },
    {
      path: "/statistics",
      name: "statistics",
      component: statistics,
    },
    {
      path: "/inform",
      name: "inform",
      component: inform,
    },

    {
      path: "/search",
      name: "search",
      component: search,
    },
    {
      path: "/result",
      name: "result",
      component: result,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js